import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBRefundDetailsPageActionButton from '../comopnents/SBRefundDetailsPageActionButton';
import SBRefundForm from '../comopnents/SBRefundForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import { useGetRefundHandler } from '../../refunds/dataHandlers/getRefundHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBRefundDetailsPage() {
  useDocumentTitle('Self Billed Refund Details');
  const { document_id } = useParams();

  const { refund, isLoading } = useGetRefundHandler(document_id);
  if (isLoading || !refund) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {refund && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Self Billed Refund Details" identifier={refund?.document_id}>
            <SBRefundDetailsPageActionButton data={refund} />
          </TopBar>
        </Box>
      )}
      <IrbmStatusCard document={refund} />
      <SBRefundForm onSubmit={() => {}} onCancel={() => {}} initialData={refund} readOnly={true} />
    </Stack>
  );
}
